import {
  Group,
  RadioGroup as MantineRadioGroup,
  type RadioGroupProps as MantineRadioGroupProps
} from "@mantine/core";
import classNames from "classnames";
import { useId } from "react";

interface RadioGroupProps extends Pick<
  MantineRadioGroupProps,
  "aria-label" | "id" | "name" | "value" | "children"
> {
  className?: string;
  errorText?: string;
  invalid?: boolean;
  layout?: "horizontal" | "vertical";
  warned?: boolean;
  ref?: React.Ref<HTMLDivElement>;
  onChange: (newValue: string) => void;
}

function RadioGroup({
  "aria-label": ariaLabel,
  className,
  errorText,
  id,
  invalid,
  layout = "horizontal",
  name,
  children,
  warned,
  value,
  ref,
  onChange
}: RadioGroupProps) {
  const backupId = useId();
  const radioGroupId = id || backupId;

  return (
    <div
      className={classNames("RadioGroup", className, {
        "is-invalid": invalid,
        warning: !invalid && warned
      })}
    >
      <MantineRadioGroup
        aria-label={ariaLabel}
        error={errorText}
        id={radioGroupId}
        name={name}
        ref={ref}
        value={value}
        onChange={onChange}
      >
        {layout === "horizontal" ? <Group>{children}</Group> : children}
      </MantineRadioGroup>
    </div>
  );
}

export { RadioGroup, RadioGroupProps };
